export const cleanUpAssessmentName = (name: string) =>
  name.replace("Direct Observation -", "");
